import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {GlobalUserStore} from '@ew/global-user';
import {toObservable} from '@angular/core/rxjs-interop';
import {filter, firstValueFrom} from 'rxjs';
import {UserRole} from '@ew/enums';

export const customerRoleGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
): Promise<boolean> => {
  const router = inject(Router);
  const global = inject(GlobalUserStore);

  const user$ = toObservable(global.user);

  const userRole = (await firstValueFrom(user$.pipe(filter((user) => user.role !== undefined))))
    .role;

  router;

  const isSecure = userRole === UserRole.CUSTOMER;

  if (!isSecure) {
    router.navigateByUrl('404');
  }

  return isSecure;
};
